import React from "react";
import { overlayBase } from "./_shared";

interface Props {
  /** Glow colour (rgba), default warm amber */
  color?: string;
  /** Pulse cycle duration seconds, default 3.5 */
  dur?: number;
}

/**
 * GlowBreathe — gentle radial pulse glow over the focal area of the banner.
 */
const GlowBreathe: React.FC<Props> = ({
  color = "rgba(255,220,150,0.35)",
  dur = 3.5,
}) => (
  <div style={overlayBase}>
    <style>{`
      @keyframes oot-breathe {
        0%, 100% { opacity: 0.35; transform: scale(1); }
        50%       { opacity: 0.7;  transform: scale(1.06); }
      }
    `}</style>
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `radial-gradient(circle at 60% 45%, ${color}, transparent 60%)`,
        animation: `oot-breathe ${dur}s ease-in-out infinite`,
      }}
    />
  </div>
);

export default GlowBreathe;
